import { Skeleton } from '@mui/material';
import { FC } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';
import { NotesSectionSkeleton } from '../../shared/notes-section/notes-section.skeleton';
import { Page, PageContent, PageTitle, Toolbar } from '../styles';
import { PatientDetailsSectionSkeleton } from './sections/patient-details/patient-details-section.skeleton';
import { PreferredDateSectionSkeleton } from './sections/preferred-date/preferred-date-section.skeleton';
import { RequestDateSectionSkeleton } from './sections/request-date/request-date-section.skeleton';

export const RequestDetailsViewSkeleton: FC = () => {
  return (
    <Page>
      <PageTitle>Appointment Details</PageTitle>
      <PageContent sx={{ margin: '0' }}>
        <Scrollbars autoHide>
          <PatientDetailsSectionSkeleton />
          <RequestDateSectionSkeleton />
          <PreferredDateSectionSkeleton />
          <NotesSectionSkeleton />
        </Scrollbars>
        <Toolbar sx={{ flexDirection: 'column', borderTop: 'none' }}>
          <Skeleton variant="rounded" width="100%" height={36} sx={{ marginBottom: '15px' }} />
          <Skeleton variant="rounded" width="100%" height={36} />
        </Toolbar>
      </PageContent>
    </Page>
  );
};
